module.exports = __webpack_public_path__ + "img/box-citas.686038c1.png";